import jquery from "jquery";

window["$"] = jquery;
window["jQuery"] = jquery;

// opzionale ma più safe
if (!globalThis["$"]) globalThis["$"] = jquery;
if (!globalThis["jQuery"]) globalThis["jQuery"] = jquery;

export default jquery;